import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as enums from '../enums'

const DOC = gql`
  query SpaceReportIds(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceReportIds
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceReportIdsQuery,
    ents.extra.space.Report.Id[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceReportIds',
                graphql.transformers.OUT.list(enums.reportId.TRANSFORMER, {
                  onNullish: 'remove',
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

/** Fetches the ids of the space reports the current user can generate. */
export const executor = graphql.createExecutor<
  graphql.schema.SpaceReportIdsQuery,
  ents.extra.space.Report.Id[],
  graphql.schema.SpaceReportIdsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
